// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"61":"06cd98a4","297":"ac22e7b0","617":"ca597d19"}[chunkId] + ".js";
};